module.exports = __webpack_public_path__ + "public/img/head.5a5ddfe8.png";